<template>
  <div class="login-page">
    <n-card class="login-card" title="Acesso restrito">
      <n-form @submit.prevent="submit">
        <n-form-item
          label="Token de acesso"
          :feedback="error"
          :validation-status="error ? 'error' : undefined"
        >
          <n-input
            v-model:value="token"
            type="password"
            show-password-on="click"
            placeholder="Cole o token de administrador"
            @keyup.enter="submit"
          />
        </n-form-item>
        <n-button
          type="primary"
          block
          attr-type="submit"
          :loading="loading"
          :disabled="!token"
          @click="submit"
        >
          Entrar
        </n-button>
      </n-form>
    </n-card>
  </div>
</template>

<script>
import { setAdminToken, verifyToken } from "../services/api";

export default {
  name: "LoginPage",
  data() {
    return {
      token: "",
      loading: false,
      error: "",
    };
  },
  methods: {
    async submit() {
      if (!this.token || this.loading) return;
      this.loading = true;
      this.error = "";
      try {
        await verifyToken(this.token.trim());
        setAdminToken(this.token.trim());
        this.$router.push(this.$route.query.redirect || "/dashboard");
      } catch (err) {
        this.error =
          err.response && err.response.status === 401
            ? "Token inválido."
            : "Não foi possível validar o token. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  max-width: 380px;
  width: 100%;
}
</style>
